
package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
actual data class SignUpParams(
    actual var name: String?  = null,
    actual var email: String  = "",
    actual var otp: Int?  = null,
    actual var password: String?  = null,
)
